import { render, staticRenderFns } from "./SampleManager.vue?vue&type=template&id=1c36e9b6&scoped=true"
import script from "./SampleManager.vue?vue&type=script&lang=js"
export * from "./SampleManager.vue?vue&type=script&lang=js"
import style0 from "./SampleManager.vue?vue&type=style&index=0&id=1c36e9b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c36e9b6",
  null
  
)

export default component.exports